import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { TimerIcon } from '../assets/icons';


const Notifications = () => {
  const notifications = [
    {
      title: 'Plan changed!',
      text: 'Your plan has been changed to “Evergreen Webinars” plan. It will renew on 24th of dec 2024',
      time: '12 mins ago',
      date: '24, Oct 2022',
      status: 'success'
    },
    {
      title: 'Plan Expired!',
      text: 'Your plan has expired.',
      linkText: 'Click here',
      time: '12 mins ago',
      date: '24, Oct 2022',
      actionType: "subscription",
      status: 'warning'
    },
    {
      title: 'Add on limit reached',
      text: 'Add on “Additional live attendees and Leads” has reached its limit.',
      linkText: 'Click here',
      time: '12 mins ago',
      date: '24, Oct 2022',
      status: 'expired'
    },
    {
      title: 'Plan changed!',
      text: 'Your plan has been changed to “Evergreen Webinars” plan. It will renew on 24th of Dec 2024.',
      time: '12 mins ago',
      date: '24, Oct 2022',
    },
    {
      title: 'Plan changed!',
      text: 'Your plan has been changed to “Evergreen Webinars” plan. It will renew on 24th of Dec 2024.',
      time: '12 mins ago',
      date: '24, Oct 2022',
    },
    {
      title: 'Plan changed!',
      text: 'Your plan has been changed to “Evergreen Webinars” plan. It will renew on 24th of Dec 2024.',
      time: '12 mins ago',
      date: '24, Oct 2022',
    },
  ];

  return (
    <Container sx={{ maxWidth: "1200px", px: "0 !Important" }}>
      <Box>
        <Typography fontWeight='500' fontSize='24px' sx={{
          marginBottom: {
            xs: "34px", sm: '20px',
            xl: '48px',
          },
        }}>
          Notifications
        </Typography>
        {notifications.map((notification, index) => (
          <Box
            key={index}
            sx={{
              display: 'flex',
              alignItems: 'center',
              backgroundColor: '#fff',
              borderRadius: '8px',
              boxShadow: '0px 4px 48px 0px #2B2B3014',
              padding: '16px',
              marginBottom: '24px',
              borderLeft:
                notification.status === "success"
                  ? "4px solid #22B060"
                  : notification.status === "warning"
                    ? "4px solid #E791BC"
                    : notification.status === "expired"
                      ? "4px solid #DEA83F"
                      : "4px solid #22B060",
              flexWrap: {
                xs: 'wrap',
                sm: 'unset',
              },
              justifyContent: {
                xs: 'flex-end',
                sm: 'space-between',
              }

            }}
          >

            <Box display='flex' gap='18px' width='100%'>
              <Box bgcolor={notification?.status === 'success' ? "#26BF941A" : notification?.status === 'warning' ? '#E791BC1A' : notification?.status === 'expired' ? '#DEA83F33' : '#26BF941A'} height='40px' width='40px' minWidth='40px' display='flex' justifyContent='center' alignItems='center' borderRadius='50%' sx={{}}><TimerIcon color={notification?.status} /></Box>
              <Box sx={{ flexGrow: 1 }}>
                <Typography fontSize='14px' color='#232323' fontFamily='Inter' marginBottom='1px'>
                  {notification.title}
                </Typography>
                <Typography fontSize="14px" color="#8C9097" marginBottom="1px">
                  {notification.text}{" "}
                  {notification.linkText && (
                    <>
                      <a
                        target="_blank"
                        style={{ color: "#178EFC", fontSize: "14px", textDecoration: 'unset' }}
                        href="#"
                      >
                        {notification.linkText}
                      </a>{" "}
                      {notification.actionType === "subscription"
                        ? "to renew your subscription."
                        : "to renew the add-on."}
                    </>
                  )}
                </Typography>
                <Typography fontSize='12px' color='#8C9097'>{notification.time}</Typography>
              </Box>
            </Box>
            <Box
              sx={{
                backgroundColor: '#614EFA1A',
                color: '#333333',
                fontSize: '12px',
                padding: '5px 10px',
                borderRadius: '5px',
                width: '91px',
                minWidth: '91px'

              }}
            >
              {notification.date}
            </Box>
          </Box>
        ))}
      </Box>
    </Container>
  );
};

export default Notifications;
